import { gsap } from 'gsap/all'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText)

export * from 'gsap'
export { gsap, SplitText }
